import { render, staticRenderFns } from "./NaturalLanguageQueryDetailView.vue?vue&type=template&id=128c438e&scoped=true"
import script from "./NaturalLanguageQueryDetailView.vue?vue&type=script&lang=js"
export * from "./NaturalLanguageQueryDetailView.vue?vue&type=script&lang=js"
import style0 from "./NaturalLanguageQueryDetailView.vue?vue&type=style&index=0&id=128c438e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c438e",
  null
  
)

export default component.exports